/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChartPeriodDto } from '../models/ChartPeriodDto';
import type { InstrumentCategory } from '../models/InstrumentCategory';
import type { InstrumentInfoDto } from '../models/InstrumentInfoDto';
import type { InstrumentOhlcDtoCollectionContainerDto } from '../models/InstrumentOhlcDtoCollectionContainerDto';
import type { InstrumentWithStatsDtoPaginationResultDto } from '../models/InstrumentWithStatsDtoPaginationResultDto';
import type { StockTradingSymbolDtoCollectionContainerDto } from '../models/StockTradingSymbolDtoCollectionContainerDto';
import type { StockTradingSymbolsGroupedDtoCollectionContainerDto } from '../models/StockTradingSymbolsGroupedDtoCollectionContainerDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class StockTradingInstrumentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param group
     * @param id
     * @param page
     * @param count
     * @returns InstrumentWithStatsDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getV1StockTradingInstruments(
        group?: InstrumentCategory,
        id?: Array<string>,
        page: number = 1,
        count: number = 100,
    ): CancelablePromise<InstrumentWithStatsDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/stock-trading/instruments',
            query: {
                'group': group,
                'id': id,
                'page': page,
                'count': count,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns StockTradingSymbolsGroupedDtoCollectionContainerDto Success
     * @throws ApiError
     */
    public getV1StockTradingInstrumentsGroups(): CancelablePromise<StockTradingSymbolsGroupedDtoCollectionContainerDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/stock-trading/instruments/groups',
        });
    }
    /**
     * @param id
     * @returns InstrumentInfoDto Success
     * @throws ApiError
     */
    public getV1StockTradingInstruments1(
        id: string,
    ): CancelablePromise<InstrumentInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/stock-trading/instruments/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns StockTradingSymbolDtoCollectionContainerDto Success
     * @throws ApiError
     */
    public getV1StockTradingInstrumentsFavorites(): CancelablePromise<StockTradingSymbolDtoCollectionContainerDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/stock-trading/instruments/favorites',
        });
    }
    /**
     * @param instrumentId
     * @returns any Created
     * @throws ApiError
     */
    public postV1StockTradingInstrumentsFavorites(
        instrumentId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/stock-trading/instruments/favorites/{instrumentId}',
            path: {
                'instrumentId': instrumentId,
            },
            errors: {
                405: `Method Not Allowed`,
            },
        });
    }
    /**
     * @param instrumentId
     * @returns void
     * @throws ApiError
     */
    public deleteV1StockTradingInstrumentsFavorites(
        instrumentId: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/stock-trading/instruments/favorites/{instrumentId}',
            path: {
                'instrumentId': instrumentId,
            },
            errors: {
                405: `Method Not Allowed`,
            },
        });
    }
    /**
     * @param instrumentId
     * @param candlesCount
     * @param timeframe
     * @param from
     * @param to
     * @returns InstrumentOhlcDtoCollectionContainerDto Success
     * @throws ApiError
     */
    public getV1StockTradingInstrumentsCharts(
        instrumentId: Array<string>,
        candlesCount: number,
        timeframe: ChartPeriodDto,
        from?: string,
        to?: string,
    ): CancelablePromise<InstrumentOhlcDtoCollectionContainerDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/stock-trading/instruments/charts',
            query: {
                'instrumentId': instrumentId,
                'candlesCount': candlesCount,
                'from': from,
                'to': to,
                'timeframe': timeframe,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
